import { useQuery } from 'react-query'
import dayjs from 'dayjs'
import { getJSON } from 'common/services/api'
import { getQueryParams } from 'utils/getQueryParams'
import {
  STOCK_DASHBOARD_SUMMARY_QUERY_KEY,
  STOCK_DASHBOARD_SUMMARY_URL
} from './queryConstants'

type MedicationRoundScheduled = {
  due: number
  signed: number
  notSigned: number
  notAdministered: number
  missed: number
}

type MedicationRound = {
  time: string
  emarRoundTimingId: string
  scheduled: MedicationRoundScheduled
  PRN: number
}

type StockDashboardSummaryAlerts = {
  lowStockCount: number
  outOfStockCount: number
  openDiscrepanciesLast30DaysCount: number
}

type StockDashboardSummaryResponse = {
  rounds: MedicationRound[]
  alerts: StockDashboardSummaryAlerts
}

type UseStockDashboardSummaryProps = {
  date?: string
  enabled?: boolean
}

type UseStockDashboardSummaryReturn = {
  data: StockDashboardSummaryResponse | null
  isLoading: boolean
  refetch: () => void
}

export const useStockDashboardSummary = (
  props: UseStockDashboardSummaryProps = {}
): UseStockDashboardSummaryReturn => {
  const { date, enabled = true } = props
  const formattedDate = date
    ? dayjs(date).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD')

  const params = getQueryParams({
    date: formattedDate
  })

  const { data, isLoading, refetch } = useQuery(
    [STOCK_DASHBOARD_SUMMARY_QUERY_KEY, formattedDate],
    () =>
      getJSON({
        url: `${STOCK_DASHBOARD_SUMMARY_URL}?${params}`
      }),
    {
      enabled,
      retry: 1
    }
  )

  return {
    data: (data as StockDashboardSummaryResponse) || null,
    isLoading,
    refetch
  }
}

export default useStockDashboardSummary
